import { METHODS } from '@system/acl/methods';
import type { UserInfo, matchesFn } from '@system/acl/types';
import { getEnvIds } from '@system/app/utils/getEnvIds';

import { EAppRouteStatus } from '@utils/enums';

const envs = getEnvIds();

export function trainMatch(
  matches: Map<string, matchesFn>,
  userInfo: UserInfo,
): void {
  // /** =======================[ Перечень поездов ]============================ */
  const isFpkl = +envs.fpklDivisionId === userInfo.divisionId;
  // Создание
  matches.set(
    METHODS.train.create,
    conditions => conditions?.status === EAppRouteStatus.StatusPlanning,
  );

  // Редактирование
  matches.set(
    METHODS.train.update,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );

  // Удаление
  matches.set(
    METHODS.train.delete,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      (!!conditions?.branchId && conditions.branchId === userInfo.branchId),
  );

  // Отправить на согласование
  matches.set(METHODS.train.toApproval, conditions =>
    !!conditions?.considerFpk && userInfo.isFpk
      ? conditions.isAgree
      : !!conditions?.branchId &&
        conditions.branchId === userInfo.branchId &&
        conditions.isAgree,
  );

  // Согласовать
  matches.set(
    METHODS.train.toApproved,
    conditions =>
      isFpkl &&
      ((!!conditions?.considerFpk && userInfo.isFpk) ||
        (!!conditions?.branchId && conditions.branchId === userInfo.branchId)),
  );

  // Согласовать подразделением
  matches.set(
    METHODS.train.approveBySubdivision,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      (!!conditions?.branchId && conditions.branchId === userInfo.branchId),
  );

  // Отклонить подразделением
  matches.set(
    METHODS.train.declineBySubdivision,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      (!!conditions?.branchId && conditions.branchId === userInfo.branchId),
  );

  // В планирование
  matches.set(
    METHODS.train.toPlanning,
    conditions =>
      (isFpkl && !!conditions?.considerFpk && userInfo.isFpk) ||
      (!!conditions?.branchId && conditions.branchId === userInfo.branchId),
  );

  // Создание версии
  matches.set(
    METHODS.train.createVersion,
    conditions =>
      conditions.status === EAppRouteStatus.StatusApproved &&
      ((!!conditions?.considerFpk && userInfo.isFpk) ||
        !conditions?.branchId ||
        conditions?.branchId === userInfo?.branchId),
  );
}
